/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {NgModule, Optional, SkipSelf} from '@angular/core';
import { CommonModule } from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {throwIfAlreadyLoaded} from './module-import.guard';
import {AuthGuard} from '../@shared/_guards/auth.guard';
import { SpinnerComponent } from './spinner/spinner.component';
import {AuthInterceptor} from '../@shared/_interceptors/auth.interceptor';
import {NoAuthGuard} from '../@shared/_guards/no-auth.guard';
import {ApiService} from '../@shared/_services/api.service';
import {GuestGuard} from '../@shared/_guards/guest.guard';
import {AccountGuard} from '../@shared/_guards/account.guard';

/**
 * Do put a singleton service whose instance will be shared throughout the application:
 * e.g. ExceptionService, LoggerService, NavComponent, SpinnerComponent
 */

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [SpinnerComponent],
  exports: [
    HttpClientModule,
    SpinnerComponent
  ],
  providers: [
    ApiService,
    AuthGuard,
    NoAuthGuard,
    GuestGuard,
    AccountGuard,
    {
      provide : HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi   : true,
    }
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
